import { Grid, Skeleton, Stack } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { colors } from 'styles/colors';

const RecentHiringActivityShimmer = () => {
  return (
    <Grid
      container
      data-testid='recent_activity_loadingSkeleton'
      sx={{
        mt: 1,
      }}
    >
      <Stack spacing={1.5} sx={{ width: '100%' }}>
        <Skeleton
          sx={{ bgcolor: (theme) => theme.palette.neutral?.main }}
          variant='rectangular'
          height={20}
          width={48}
          animation='wave'
        />
        {Array.from({ length: 2 }, (_, index) => (
          <Box
            key={index}
            display={'flex'}
            flexDirection={'column'}
            gap={0.5}
            sx={{
              p: '0.75rem 1rem',
              border: `1px solid ${colors.border.disabledGray}`,
              borderRadius: 1,
            }}
          >
            <Skeleton
              sx={{ bgcolor: (theme) => theme.palette.neutral?.main }}
              variant='rectangular'
              height={30}
              width='50%'
              animation='wave'
            />
            <Skeleton
              sx={{ bgcolor: (theme) => theme.palette.neutral?.main }}
              variant='rectangular'
              height={20}
              animation='wave'
            />
          </Box>
        ))}
      </Stack>
    </Grid>
  );
};

export default RecentHiringActivityShimmer;
